import React from 'react'
import { useTranslation } from 'react-i18next';
import ReservationsList from './ReservationsList';

const ReservationsTab = () => {
    const { t } = useTranslation();
  return (
    <div className="tab-content__container">
        <h5>{t('twoje_rezerwacje')}</h5>

        <ReservationsList />
    </div>
  )
}

export default ReservationsTab